import Logo from "@/assets/regions/barnet-logo.svg";
import { DefaultLower } from "@/model/DefaultBanners";
import { RiskLevel } from "@/model/RiskLevel";
const BarnetDefault = {
    rawCopy: "For alcohol advice and support, call Change Grow Live Barnet " +
        "on 0300 303 2866.",
    logoLink: "https://www.wdp.org.uk/find-us/london/barnet-0"
};
const BarnetTest = {
    rawCopy: "If you would like to speak to someone about your drinking, " +
        "why not <u>book a free online appointment</u> with a DrinkCoach alcohol specialist.",
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/14"
};
export default {
    name: "Barnet",
    logo: {
        file: Logo,
        width: 170,
        height: 46
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    regions: [
        "Brunswick Park",
        "Burnt Oak",
        "Childs Hill",
        "Colindale",
        "Coppetts",
        "East Barnet",
        "East Finchley",
        "Edgware",
        "Finchley Church End",
        "Garden Suburb",
        "Golders Green",
        "Hale",
        "Hendon",
        "High Barnet",
        "Mill Hill",
        "Oakleigh",
        "Totteridge",
        "Underhill",
        "West Finchley",
        "West Hendon",
        "Woodhouse"
    ],
    bannerInfo: {
        default: BarnetTest,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: BarnetDefault,
        [RiskLevel.Higher]: BarnetDefault,
        [RiskLevel.High]: BarnetDefault
    },
    clinics: [
        {
            name: "Change Grow Live | Barnet",
            tagline: "Drug and Alcohol Service",
            address: "Ground Floor, Dennis Scott Unit, Edgware Community Hospital, " +
                "Burnt Oak Broadway, Edgware, HA8 0AD",
            isPrimaryProvider: true,
            // description: "hide",
            phone: ["0300 303 2866"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 930, end: 1330 }, { start: 1530, end: 1700 }],
                        tuesday: [{ start: 930, end: 1700 }],
                        wednesday: [{ start: 930, end: 1700 }],
                        thursday: [{ start: 930, end: 1700 }],
                        friday: [{ start: 930, end: 1700 }]
                    }
                }
            ],
            website: "https://changegrowlive.org/",
            email: "barnet.info@cgl.org.uk",
            other_info: "For self referrals visit <a href='https://changegrowlive.org/barnet/referrals' target='_blank'>changegrowlive.org/barnet/referrals</a>",
            location: {
                lat: 51.60641829999999,
                lng: -0.2710676000000376
            }
        },
        {
            name: "The Clinic",
            address: "280 Oakleigh Road North, Barnet, London N20 0DH",
            phone: ["020 8361 3638"],
            location: {
                lat: 51.6251723,
                lng: -0.1588289999999688
            }
        },
        {
            name: "Lichfield Grove Surgery",
            address: "64 Lichfield Grove, Barnet, London N3 2JP",
            phone: ["020 8346 3123"],
            location: {
                lat: 51.5988184,
                lng: -0.19188499999995656
            }
        },
        {
            name: "Greenfield Medical Centre",
            address: "143 - 145 Cricklewood Lane, Barnet, London NW2 1HS",
            phone: ["020 8450 5454"],
            location: {
                lat: 51.56099649999999,
                lng: -0.20559579999996913
            }
        },
        {
            name: "Squires Lane Medical Practice",
            address: "2 Squires Lane, Barnet, London N3 2AU",
            phone: ["020 8346 1516"],
            location: {
                lat: 51.6024884,
                lng: -0.17497639999999137
            }
        },
        {
            name: "Heathfielde Medical Centre",
            address: "8 Lyttleton Road, Barnet, London N2 0EQ",
            phone: ["020 8458 9262"],
            location: {
                lat: 51.5853076,
                lng: -0.1797295999999733
            }
        },
        {
            name: "PHGH Doctors",
            address: "Temple Fortune Health Centre, 23 Temple Fortune Lane, London NW11 7TE",
            phone: ["020 8209 2400"],
            location: {
                lat: 51.58103190000001,
                lng: -0.1977618999999322
            }
        },
        {
            name: "The Speedwell Practice",
            address: "The Health Centre, 16 Torrington Park, London N12 9SS",
            phone: ["020 8445 7587"],
            location: {
                lat: 51.6170378,
                lng: -0.17511709999996583
            }
        },
        {
            name: "The Everglade Medical Practice",
            address: "Grahame Park Health Centre, The Concourse, London NW9 5XT",
            phone: ["020 8432 8641"],
            location: {
                lat: 51.6015691,
                lng: -0.2442246000000523
            }
        },
        {
            name: "The Old Courthouse Surgery",
            address: "27 Wood Street, Barnet, London EN5 4BB",
            phone: ["020 8449 2388"],
            location: {
                lat: 51.6528989,
                lng: -0.20157819999997173
            }
        },
        {
            name: "Cornwall House Surgery",
            address: "Cornwall Avenue, Barnet, London N3 1LD",
            phone: ["020 8346 1976"],
            location: {
                lat: 51.6049526,
                lng: -0.1896610999999666
            }
        },
        {
            name: "Millway Medical Practice",
            address: "2 Hartley Avenue, Barnet, London NW7 2HX",
            phone: ["020 8959 0888"],
            location: {
                lat: 51.61551550000001,
                lng: -0.243940000000066
            }
        },
        {
            name: "Longrove Surgery",
            address: "70 Union Street, Barnet, London EN5 4HT",
            phone: ["020 8370 6660"],
            location: {
                lat: 51.6539025,
                lng: -0.20474319999993895
            }
        },
        {
            name: "Watling Medical Centre",
            address: "108 Watling Avenue, Edgware, London HA8 0NR",
            phone: ["020 8906 1711"],
            location: {
                lat: 51.6033559,
                lng: -0.26206070000000636
            }
        },
        {
            name: "St George's Medical Centre",
            address: "7 Sunningfields Road, Barnet, London NW4 4QR",
            phone: ["020 8202 6232"],
            location: {
                lat: 51.5927778,
                lng: -0.22584729999994124
            }
        },
        {
            name: "Torrington Park Group Practice",
            address: "16 Torrington Park, Barnet, London N12 9SS",
            phone: ["020 3667 5030"],
            location: {
                lat: 51.6171696,
                lng: -0.175119699999982
            }
        },
        {
            name: "St Andrews Medical Practice",
            address: "50 Oakleigh Road North, Barnet, London N20 9EX",
            phone: ["020 8445 0475"],
            location: {
                lat: 51.6301723,
                lng: -0.17206150000004072
            }
        },
        {
            name: "Pennine Drive Surgery",
            address: "8 Pennine Drive, Barnet, London NW2 1PA",
            phone: ["020 8455 9977"],
            location: {
                lat: 51.568466,
                lng: -0.20886410000002797
            }
        },
        {
            name: "Supreme Medical Centre",
            address: "Ground Floor Supreme House, Barnet, London N3 2JX",
            phone: ["020 8346 3291"],
            location: {
                lat: 51.5993888,
                lng: -0.19533109999997578
            }
        },
        {
            name: "The Practice @ 188",
            address: "188 Golders Green Road, Barnet, London NW11 9AY",
            phone: ["020 8298 6498"],
            location: {
                lat: 51.5760173,
                lng: -0.20437709999998788
            }
        },
        {
            name: "Parkview Surgery",
            address: "36 Cressingham Road, Edgware, London HA8 0RW",
            phone: ["020 8906 7980"],
            location: {
                lat: 51.60722579999999,
                lng: -0.2576367000000346
            }
        },
        {
            name: "Penshurst Gardens",
            address: "39 Penshurst Gardens, Edgware, London HA8 9TN",
            phone: ["020 8958 3141"],
            location: {
                lat: 51.61614059999999,
                lng: -0.2728038000000197
            }
        },
        {
            name: "The Village Surgery",
            address: "113 East Barnet Road, Barnet, London EN4 8RF",
            phone: ["020 8449 6443"],
            location: {
                lat: 51.6481935,
                lng: -0.1682872999999745
            }
        },
        {
            name: "Oak Lodge Medical Centre",
            address: "234 Burnt Oak Broadway, Edgware, London HA8 0AP",
            phone: ["020 8952 1202"],
            location: {
                lat: 51.6043695,
                lng: -0.2717159999999694
            }
        },
        {
            name: "Doctors Surgery",
            address: "192 Colney Hatch Lane, Barnet, London N10 1ET",
            phone: ["020 8883 5555"],
            location: {
                lat: 51.6013127,
                lng: -0.14755800000000363
            }
        },
        {
            name: "Wentworth Medical Practice",
            address: "38 Wentworth Avenue, Barnet, London N3 1YL",
            phone: ["020 8346 1242"],
            location: {
                lat: 51.6077587,
                lng: -0.18791690000000472
            }
        },
        {
            name: "Vale Drive Medical Practice",
            address: "Vale Drive Health Centre, Vale Drive, London EN5 2ED",
            phone: ["020 8447 3566"],
            location: {
                lat: 51.64895749999999,
                lng: -0.19456590000004326
            }
        },
        {
            name: "Derwent Medical Centre",
            address: "20 Derwent Crescent, Barnet, London N20 0QQ",
            phone: ["020 8446 0171"],
            location: {
                lat: 51.6226326,
                lng: -0.17521110000006956
            }
        },
        {
            name: "Jai Medical Centre",
            address: "114 Edgwarebury Lane, Barnet, London HA8 8NB",
            phone: ["030 0033 7861"],
            location: {
                lat: 51.621877,
                lng: -0.2775540000000092
            }
        },
        {
            name: "Ravenscroft Medical Centre",
            address: "166-168 Golders Green Road, Barnet, London NW11 8BB",
            phone: ["02084552477", "02084559530"],
            location: {
                lat: 51.57528920000001,
                lng: -0.2027702999999974
            }
        },
        {
            name: "Wakeman's Hill Surgery",
            address: "1 Wakeman's Hill Avenue, Barnet, London NW9 0TA",
            phone: ["020 8205 2336"],
            location: {
                lat: 51.587597,
                lng: -0.2525591999999506
            }
        },
        {
            name: "Addington Medical Centre",
            address: "46 Station Road, Barnet, London EN5 1QH",
            phone: ["020 8441 4425"],
            location: {
                lat: 51.649507,
                lng: -0.17744300000003932
            }
        },
        {
            name: "Friern Barnet Medical Centre",
            address: "16 St. Johns Villas, Barnet, London N11 3BU",
            phone: ["020 8368 1707"],
            location: {
                lat: 51.6132719,
                lng: -0.1564276000000291
            }
        },
        {
            name: "Mulberry Medical Practice",
            address: "3 Sefton Avenue, Barnet, London NW7 3QB",
            phone: ["020 8959 1868"],
            location: {
                lat: 51.6154042,
                lng: -0.2603434999999763
            }
        },
        {
            name: "Langstone Way Surgery",
            address: "28 Langstone Way, Barnet, London NW7 1GR",
            phone: ["020 8343 2401"],
            location: {
                lat: 51.60699,
                lng: -0.21067429999993692
            }
        },
        {
            name: "East Finchley Medical Practice",
            address: "39 Baronsmere Road, Barnet, London N2 9QD",
            phone: ["020 8883 1458"],
            location: {
                lat: 51.588095,
                lng: -0.16204949999996643
            }
        },
        {
            name: "Lane End Medical Group",
            address: "2 Penshurst Gardens, Edgware, London HA8 9GJ",
            phone: ["020 8958 4233"],
            location: {
                lat: 51.6153339,
                lng: -0.27480769999999666
            }
        },
        {
            name: "Adler & Rosenberg (682 Finchley Road)",
            address: "682 Finchley Road, Barnet, London NW11 7NP",
            phone: ["020 8455 9994"],
            location: {
                lat: 51.5753663,
                lng: -0.1960569000000305
            }
        },
        {
            name: "East Barnet HC (Monkman)",
            address: "East Barnet Health Centre, 149 East Barnet Road, Barnet EN4 8QZ",
            phone: ["020 8440 7417"],
            location: {
                lat: 51.64671999999999,
                lng: -0.1666966999999886
            }
        },
        {
            name: "Brunswick Park Medical Practice",
            address: "Brunswick Park Health Centre, Brunswick Park Road, London N11 1EY",
            phone: ["020 8368 1568"],
            location: {
                lat: 51.6301212,
                lng: -0.14916429999993852
            }
        },
        {
            name: "Temple Fortune Health Centre",
            address: "23 Temple Fortune Lane, London NW11 7TE",
            phone: ["020 8209 2401"],
            location: {
                lat: 51.58109349999999,
                lng: -0.19778539999992972
            }
        },
        {
            name: "Station Road Surgery",
            address: "33b Station Road, Barnet, London EN5 1PH",
            phone: ["020 8449 3842"],
            location: {
                lat: 51.6488887,
                lng: -0.17805670000007012
            }
        },
        {
            name: "East Barnet HC (Dr Weston & Dr Helbtitz)",
            address: "East Barnet Health Centre, 149 East Barnet Road, Barnet EN4 8QZ",
            phone: ["020 8440 7417"],
            location: {
                lat: 51.64671999999999,
                lng: -0.1666966999999886
            }
        },
        {
            name: "East Barnet HC (Dr Peskin/Syed/Hussain)",
            address: "East Barnet Health Centre, 149 East Barnet Road, Barnet EN4 8QZ",
            phone: ["020 8440 7417"],
            location: {
                lat: 51.64671999999999,
                lng: -0.1666966999999886
            }
        },
        {
            name: "Dr Lamba (Colindeep Lane)",
            address: "61 Colindeep Lane, Barnet, London NW9 6DJ",
            phone: ["020 8205 6798"],
            location: {
                lat: 51.5911971,
                lng: -0.2484386999999515
            }
        },
        {
            name: "Mountfield Surgery",
            address: "55 Mountfield Road, Barnet, London N3 3NR",
            phone: ["020 8346 4271"],
            location: {
                lat: 51.5947419,
                lng: -0.19326860000001034
            }
        },
        {
            name: "Rosemary Surgery",
            address: "2 Rosemary Avenue, Barnet, London N3 2QN",
            phone: ["020 8346 1997"],
            location: {
                lat: 51.5976593,
                lng: -0.18582330000003822
            }
        },
        {
            name: "Rosemary Surgery",
            address: "2 Rosemary Avenue, Barnet, London N3 2QN",
            phone: ["020 8346 1997"],
            location: {
                lat: 51.5976593,
                lng: -0.18582330000003822
            }
        },
        {
            name: "Hodford Road Surgery",
            address: "73 Hodford Road, Barnet, London NW11 8NH",
            phone: ["020 8905 5234"],
            location: {
                lat: 51.5692396,
                lng: -0.19923419999997805
            }
        },
        {
            name: "Gloucester Road Surgery",
            address: "1B Gloucester Road, Barnet, London EN5 1RS",
            phone: ["020 8449 7677"],
            location: {
                lat: 51.6473858,
                lng: -0.18332099999997808
            }
        },
        {
            name: "The Phoenix Practice",
            address: "7 Brampton Grove, Barnet, London NW4 4AE",
            phone: ["020 8202 9030"],
            location: {
                lat: 51.58758659999999,
                lng: -0.22205489999998917
            }
        },
        {
            name: "Hillview Surgery",
            address: "114 Finchley Lane, Barnet, London NW4 1DG",
            phone: ["020 8203 0546"],
            location: {
                lat: 51.59001800000001,
                lng: -0.21429239999997662
            }
        },
        {
            name: "Deans Lane Medical Centre",
            address: "156 Deans Way, Edgware, London HA8 9NT",
            phone: ["020 8906 3337"],
            location: {
                lat: 51.61617589999999,
                lng: -0.26035699999999906
            }
        },
        {
            name: "Woodlands Medical Practice",
            address: "54 Leopold Road, Barnet, London N2 8BG",
            phone: ["0208 442 2339"],
            location: {
                lat: 51.5933357,
                lng: -0.17064700000003086
            }
        },
        {
            name: "Cricklewood Health Centre",
            address: "Britannia Business Centre, Cricklewood Lane, London NW2 1DZ",
            phone: ["03000 334 335"],
            location: {
                lat: 51.557492,
                lng: -0.2152925000000323
            }
        },
        {
            name: "Hendon Way Surgery",
            address: "215 W Hendon Broadway, Barnet, London NW9 7DG",
            phone: ["020 8102 9830"],
            location: {
                lat: 51.5786489,
                lng: -0.24120349999998325
            }
        },
        {
            name: "Dr Azim & Partners",
            address: "67 Elliot Road, Barnet, London NW4 3EB",
            phone: ["020 8457 3950"],
            location: {
                lat: 51.5796281,
                lng: -0.22570150000001377
            }
        }
    ]
};
//# sourceMappingURL=Barnet.js.map